<template>
    <div class="container sizes mt-5">
        <div class="row">
            <div class="block-title">Калькуляция</div>
        </div>
        <div class="row">
            <div class="stock child-table-w100-lg mt-3">
                <div class="table-responsive">
                    <table class="table table-stock table-borderless">
                        <tbody>
                        <tr>
                            <td class="sticky">
                                <!-- table-stock-sticky -->
                                <table class="table table-stock-sticky table-regular table-text-left align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">Бренды</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>Puma</td>
                                    </tr>
                                    <tr>
                                        <td>Adidas</td>
                                    </tr>
                                    <tr>
                                        <td>Nike</td>
                                    </tr>
                                    <tr>
                                        <td>Under Armour</td>
                                    </tr>
                                    <tr>
                                        <td>Прочие бренды</td>
                                    </tr>
                                    <tr>
                                        <td class="total">Итого</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-sticky -->
                            </td>
                            <td class="slidy">
                                <!-- table-stock-slidy -->
                                <table class="table table-stock-slidy table-regular table-borderless align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">В корзине</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>415 992Р</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>325 992Р</td>
                                    </tr>
                                    <tr>
                                        <td class="total total-cart">415 992Р</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-slidy -->
                            </td>
                            <td class="slidy">
                                <!-- table-stock-slidy -->
                                <table class="table table-stock-slidy table-regular table-borderless align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">Текущая оптовая скидка</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>10%</td>
                                    </tr>
                                    <tr>
                                        <td>10%</td>
                                    </tr>
                                    <tr>
                                        <td>25%</td>
                                    </tr>
                                    <tr>
                                        <td>10%</td>
                                    </tr>
                                    <tr>
                                        <td>10%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-slidy -->
                            </td>
                            <td class="slidy">
                                <!-- table-stock-slidy -->
                                <table class="table table-stock-slidy table-regular table-borderless align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">Возможная оптовая скидка</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>35% <span class="muted">(добавьте на 200 000Р)</span></td>
                                    </tr>
                                    <tr>
                                        <td>35% <span class="muted">(добавьте на 200 000Р)</span></td>
                                    </tr>
                                    <tr>
                                        <td>30% <span class="muted">(добавьте на 84 008Р)</span></td>
                                    </tr>
                                    <tr>
                                        <td>25% <span class="muted">(добавьте на 200 000Р)</span></td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td><a href="#">Таблица оптовых скидок</a></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-slidy -->
                            </td>
                            <td class="slidy">
                                <!-- table-stock-slidy -->
                                <table class="table table-stock-slidy table-regular table-borderless align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">Выгода</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>103 998Р</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>32 600Р</td>
                                    </tr>
                                    <tr>
                                        <td class="total">136 598Р</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-slidy -->
                            </td>
                            <td class="slidy">
                                <!-- table-stock-slidy -->
                                <table class="table table-stock-slidy table-regular table-borderless align-middle">
                                    <thead>
                                    <tr class="table-regular-h2">
                                        <th class="muted">Cумма со скидкой</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-group-divider">
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>311 994Р</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <td>293 392Р</td>
                                    </tr>
                                    <tr>
                                        <td class="total invert">605 386Р</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- /table-stock-slidy -->
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
    },
    computed: {
        // items() {
        //     return this.$store.state.cart.items;
        // },
        // total() {
        //     return this.$store.state.cart.total;
        // },
    },
};
</script>
